import { enumToOptions } from '@app/shared/helpers';
import { ESGTermsInherentOrVestingRelated } from '@app/shared/models/contracts/enums/shared-enums';
import { l, translationKeys } from '@locale/setupI18n';

export const getEsgTermsOptions = () =>
  enumToOptions(ESGTermsInherentOrVestingRelated, undefined, true).map((o) => ({
    viewValue: l(o.viewValue as translationKeys),
    value: o.value,
  }));
